module.exports = __webpack_public_path__ + "static/media/Dobro - map icons_Parkirni centar za jaja icon (1).8d7fe271.svg";